import { Button, Grid } from '@chakra-ui/react'
import { useSsoLogin } from 'BrokerTsLib/src/hooks'
import { Lock } from '../icons'

export const SSOLoginButtons = ({ returnUrl }: { returnUrl?: string }) => {
    const [isLoggingInOkHolding, loginOkHolding] = useSsoLogin('okholding', returnUrl)
    const [isLoggingInOkKlient, loginOkKlient] = useSsoLogin('okklient', returnUrl)

    return <Grid
        sx={{ w: '100%', gap: 2, gridTemplateColumns: '1fr 1fr', justifyContent: 'center' }}
    >
        <Button colorScheme="primary" isLoading={isLoggingInOkHolding} isDisabled={isLoggingInOkKlient} onClick={loginOkHolding}>
            <Lock />
            SSO OK HOLDING
        </Button>

        <Button variant="outline" isLoading={isLoggingInOkKlient} isDisabled={isLoggingInOkHolding} onClick={loginOkKlient}>
            <Lock />
            OK KLIENT
        </Button>
    </Grid>
}